import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { PageHeader, Pagination } from "./AdminShared";
import { fmtDate } from "@/components/StatusBadge";
import { useState } from "react";
import { ScrollText } from "lucide-react";

export default function AdminLogs() {
  const [page, setPage] = useState(1);
  const { data } = useQuery({ queryKey: ["admin-logs", page], queryFn: async () => (await api.get("/admin/logs", { params: { page, limit: 20 } })).data });
  const items = data?.items || [];
  return (
    <div>
      <PageHeader title="Activity Logs" subtitle="Audit trail of admin actions" />
      <div className="glass rounded-2xl overflow-hidden">
        <div className="divide-y divide-white/5">
          {items.length === 0 ? (
            <div className="px-6 py-10 text-center text-slate-500">No activity yet.</div>
          ) : items.map((l) => (
            <div key={l.id} className="px-5 py-4 flex items-center gap-4" data-testid={`log-${l.id}`}>
              <div className="w-9 h-9 rounded-lg bg-purple-500/15 text-purple-400 flex items-center justify-center shrink-0"><ScrollText className="w-4 h-4" /></div>
              <div className="flex-1 min-w-0">
                <div className="text-white text-sm font-medium capitalize">{l.action.replace(/_/g, " ")}</div>
                <div className="text-xs text-slate-500 truncate">{l.actor_email} {l.detail ? `· ${l.detail}` : ""}</div>
              </div>
              <div className="text-xs text-slate-500 shrink-0">{fmtDate(l.created_at)}</div>
            </div>
          ))}
        </div>
        <Pagination page={page} total={data?.total || 0} limit={20} onPage={setPage} />
      </div>
    </div>
  );
}
